import { createRouteRef } from '@backstage/core-plugin-api';

export const exploreRouteRef = createRouteRef({ id: 'ea-pack:explore' });
export const homeRouteRef = createRouteRef({ id: 'ea-pack:home' });
export const apisRouteRef = createRouteRef({ id: 'ea-pack:apis' });
export const adminRouteRef = createRouteRef({ id: 'ea-pack:admin' });
export const adminCatalogRouteRef = createRouteRef({ id: 'ea-pack:admin-catalog' });
export const contributeRouteRef = createRouteRef({ id: 'ea-pack:contribute' });
